import { NgModule } from '@angular/core';
import { BgColorDirective } from './bg-color/bg-color';
import { BtnColorDirective } from './btn-color/btn-color';
import { TextColorDirective } from './text-color/text-color';
import { HeaderBgColorDirective } from './header-bg-color/header-bg-color';
import { FooterBgColorDirective } from './footer-bg-color/footer-bg-color';
import { HeaderTextColorDirective } from './header-text-color/header-text-color';
@NgModule({
	declarations: [BgColorDirective,
    BtnColorDirective,
    TextColorDirective,
    HeaderBgColorDirective,
    FooterBgColorDirective,
    HeaderTextColorDirective],
	imports: [],
	exports: [BgColorDirective,
    BtnColorDirective,
    TextColorDirective,
    HeaderBgColorDirective,
    FooterBgColorDirective,
    HeaderTextColorDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts